import Dialog from './dialog';
import Page from './page';
import COMMON_API from './api/v2/common/index';

export { Dialog, Page };
const baseURL = process.env.BASE_URL;
export function copyText(text, notTip){
	if (typeof navigator == 'object' && typeof navigator.clipboard == 'object') {
		navigator.clipboard.writeText(text).then(() => {
			if (!notTip) {
				Dialog.success('已复制到剪贴板');
			}
		});
	} else {
		const temp = document.createElement('textarea');
		temp.value = text;
		document.body.appendChild(temp);
		temp.select();
		const success = document.execCommand("copy");
		if (success) {
			if (!notTip) {
				Dialog.success('已复制到剪贴板');
			}
		}
		document.body.removeChild(temp);
	}
}

// 生产随机数
export function generateMixed(n) {
	var res = "";
	var chars = ['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
	for(var i = 0; i < n ; i ++) {
		var id = Math.ceil(Math.random()*35);
		res += chars[id];
	}
	return res;
}

export const DateUtils = {
  format(date, fmt) {
    if (typeof date != 'object') {
      return date;
    }
    var o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "H+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },
  formatDateTime(date) {
    return this.format(date, 'yyyy-MM-dd HH:mm:ss');
  },
  formatTsToDate(timestamp) {
    const date = new Date(timestamp);
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${d} ${h}:${mi}:${s}`;
  },
  formatDate(date) {
    return this.format(date, 'yyyy-MM-dd');
  },
  getMonthFrist(timestamp) {
    let date = timestamp ? new Date(timestamp) : new Date()
    let year = date.getFullYear()
    let month = date.getMonth()+1;
    if(month<10){
      month = '0'+month;
    }
    return year+'-'+month+'-01 00:00:00';
  },
  getMonthLast(timestamp) {
    let date = timestamp ? new Date(timestamp) : new Date()
    let year = date.getFullYear()
    let month = date.getMonth()+1
    let nowDate = (new Date(year, month, 0) / 1000 + 86399) * 1000;
    date = new Date(nowDate)
    if(date.getMonth()<10){
      month = '0'+month;
    }
    return date.getFullYear()+'-'+month+'-'+date.getDate()+' 23:59:59';
  },
}

export const CookieUtil = {
  getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

    if (arr = document.cookie.match(reg))

      return unescape(arr[2]);
    else
      return null;
  },
  delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null) {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },
  setCookie(name, value) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  }
}

/***
 *
 * 获取请求的UUID，指定长度和进制,如
 * getUUID(8, 2)   //"01001010" 8 character (base=2)
 * getUUID(8, 10) // "47473046" 8 character ID (base=10)
 * getUUID(8, 16) // "098F4D35"。 8 character ID (base=16)
 *
 */
export function getUUID(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [], i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
  } else {
    var r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random()*16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}

export function openWindow(url, width, height, title) {
  var screenHeight = window.screen.height;
  var screenWidth = window.screen.width;
  var top = 0;
  var left = 0;
  if (width) {
    width = parseInt(width);
  } else {
    width = 500;
  }
  if (height) {
    height = parseInt(height);
  } else {
    height = 400;
  }
  if (width > screenWidth - 100) {
    width = screenWidth - 100;
  }

  if (height > screenHeight - 100) {
    height = screenHeight - 100;
  }

  left = (screenWidth - width) / 2;
  top = (screenHeight - height) / 2 - 35;
  window.open (url, title ? title : 'newwindow', 'height=' + height + ', width=' + width + ', top=' + top + ', left=' + left + ', toolbar=no, menubar=no, scrollbars=no,resizable=no,location=no, status=no');
}

export const FileUtils = {
	upload(params) {
		let afterUploadResolve;
		const promise = new Promise(resolve => {
			afterUploadResolve = resolve;
		});
		if (params && params.file && params.url) {
			const file = params.file;
			const maxSize = params.maxSize;
			const url = params.url;
			const accept = params.accept;
			if (maxSize) {
				if (!this.checkFileSize(file, maxSize)) {
					Dialog.error('文件大小超出限制');
					return;
				}
			}
			if (accept) {
				if (!this.checkFileType(file, accept)) {
					Dialog.error('文件类型不合法');
					return;
				}
			}
			const form = new FormData();
			form.append('file', file);
			const xhr = new XMLHttpRequest();
			const uploadProgress = params.uploadProgress;
			const uploadComplete = params.uploadComplete;
			const uploadFailed = params.uploadFailed;
			const uploadCanceled = params.uploadCanceled;
			if (uploadComplete) {
				xhr.upload.addEventListener('load', uploadComplete, false);
			}
			if (uploadProgress) {
				xhr.upload.addEventListener('progress', uploadProgress, false);
			}
			if (uploadFailed) {
				xhr.upload.addEventListener('error', uploadFailed, false);
			}
			if (uploadCanceled) {
				xhr.upload.addEventListener('abort', uploadCanceled, false);
			}
			xhr.onreadystatechange = function(e) {
				const xmlHttpRequest = e.target;
				if(xmlHttpRequest.readyState == 4 && xmlHttpRequest.status == 200){
					const responseText = xmlHttpRequest.responseText;
					console.log(responseText);
					try {
						afterUploadResolve(JSON.parse(responseText));
					} catch (e) {
						console.log(e);
					}
				}
			};
			xhr.open('POST', url, true); //修改成自己的接口
			xhr.send(form);
		}
		return promise;
	},
	checkFileSize(file, maxSize) {
		if (file && maxSize) {
			if (typeof maxSize == 'string') {
				maxSize = maxSize.toUpperCase();
				if (maxSize.endWith('K') || maxSize.endWith('KB')) {
					maxSize = parseInt(maxSize);
				} else {
					maxSize = parseInt(maxSize) * 1024;
				}
			} else if(typeof maxSize == 'number')  {
				maxSize = maxSize * 1024;
			} else {
				return true;
			}
			// 获取文件大小，转换KB
			const fileSize = Math.round(file.size * 100 / 1024) / 100;
			if (fileSize > maxSize) {
				return false
			} else {
				return true;
			}
		}
	},
	checkFileType(file, types) {
		if (file && types) {
			const fileName = file.name;
			let rightType = false;
			types.map(type => {
				if (type) {
					if (!type.startWith('.')) {
						type = '.' + type;
					}
					if (fileName.endWith(type)) {
						rightType = true;
					}
				}
			});
			return rightType;
		} else {
			return true;
		}
	},
}
export const  regex = {
  "mobile" : /^\d{6,20}$/,
  "phone" : /^\d+-\d+(?:-\d+)?$/,
  "email" : /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
  "float": /^\d+(\.\d+)?$/,
  "int" : /^-?[0-9]\d*$/, // 匹配正整数和负整数
  "post" : /^[\da-zA-Z\-]{3,10}$/,
  "addressDetail" : /^.{5,120}$/,
  "name" : /^.{2,25}$/,
  "tid" : /^\d{16,}$/
}

export function decryptPddOrderInfo(method, mallId, orderSn, decryptReportType) {
	return new Promise((resolve, reject) => {
		const verifyAuthToken = CookieUtil.getCookie('verifyAuthToken_' + mallId);
		if (!decryptReportType) {
			decryptReportType = window.localStorage.getItem('decryptReportType');
		}
		if (!decryptReportType) {
			decryptReportType = '1';
		}
    COMMON_API.decryptPddOrderInfo(method, { mallId, orderSn, 'X-PDD-VerifyAuthToken': verifyAuthToken, decryptReportType }).then(result => {
			if (!result.error_msg) {
				const orderInfo = result.order_info;
				resolve(orderInfo);
			} else {
				console.log(result);
				if (result.error_code == 54001) {
					Dialog.alert(result.error_msg).then(() => {
						const redirectURL = `${baseURL}pdd/auth/checkRobot/callback/${result.mall_id}`;
						window.location = `https://fuwu.pinduoduo.com/service-market/are-you-robot?mall_id=${result.mall_id}&client_id=${result.client_id}&verifyAuthToken=${result.risk_info.verify_auth_token}&redirect_url=${redirectURL}`;
					});
				} else {
					Dialog.error(result.error_msg);
				}
				reject(result);
			}
		});
	});
}



// WEBPACK FOOTER //
// ./src/utils/index.js